import type { RequestQueryOptions } from '@entities/lesson/model/types/api'
import { rpc } from '@server/infrastructure/rpc'
import { queryOptions } from '@tanstack/react-query'

import type { RecentTutorsResponse, TutorExclusionListResponse } from '../model'

export const tutorExclusionQueries = {
  all: ['tutor-exclusion'],

  listQueryKey: (bearerToken: string) => [...tutorExclusionQueries.all, 'list', bearerToken],

  recentTutorsQueryKey: (bearerToken: string) => [...tutorExclusionQueries.all, 'recent-tutors', bearerToken],

  list: ({ bearerToken }: RequestQueryOptions) =>
    queryOptions({
      queryKey: tutorExclusionQueries.listQueryKey(bearerToken),
      queryFn: async () => {
        const response = await rpc.api.v1['tutor-exclusion'].list.$get(
          {},
          { headers: { Authorization: `Bearer ${bearerToken}` } },
        )
        return response.json() as Promise<TutorExclusionListResponse>
      },
    }),

  recentTutors: ({ bearerToken }: RequestQueryOptions) =>
    queryOptions({
      queryKey: tutorExclusionQueries.recentTutorsQueryKey(bearerToken),
      queryFn: async () => {
        const response = await rpc.api.v1['tutor-exclusion']['recent-tutors'].$get(
          {},
          { headers: { Authorization: `Bearer ${bearerToken}` } },
        )
        return response.json() as Promise<RecentTutorsResponse>
      },
    }),
} as const
